import ProductCard from './ProductCard';
import ProductCardPresentation from './ProductCardPresentation';

export default ProductCard;

export { ProductCardPresentation };
